exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku_title[data-v-58e6b1fc]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.bottom_button[data-v-58e6b1fc]{padding-top:1px;position:fixed;bottom:0;width:100%;background-color:#fff;-webkit-box-shadow:1px -1px 3px #888;box-shadow:1px -1px 3px #888}", ""]);

// exports
